
<section class="footer-section text-black pt-5 pb-4">
  <div class="container-fluid px-lg-5">
    <div class="row g-4 align-items-start">

      <!-- 1. Logo & Instagram -->
      <div class="col-12 col-sm-6 col-lg-3 text-center pe-lg-4">
        <a href="https://budgetbazaar.cktechsoln.in/">
          <img src="../../../assets/img/budget-logo.png" alt="Budget Bazaar" class="footer-logo mb-3">
        </a>
        <!-- <p class="small text-black josefin-sans-regular">
          Your one-stop destination for groceries, snacks, and more — delivered fresh to your door.
        </p> -->
        <div class="d-flex justify-content-center mt-2">
          <div class="col-lg-6  yt-channel-card">
          <a href="https://www.instagram.com/its_budget_bazaar?igsh=MWExdjB0eXJ5cDNhNw==" target="_blank"
            class="social-icon"><i class="fab fa-instagram"></i></a> Instagram
            </div>
        </div>
      </div>

      <!-- 2. YouTube Channels -->
      <div class="col-12 col-sm-6 col-lg-3">
        <h5 class="footer-title josefin-sans-bold mb-4 text-center">
          Our YouTube Channels
        </h5>

        <div class="d-flex flex-column gap-3">

          <a
            href="https://youtube.com/&#64;jointsareecollection?si=CQ6cIM-XsMeDbkMp"
            target="_blank"
            rel="noopener noreferrer"
            class="yt-channel-card"
          >
            <div class="yt-icon-wrap">
              <i class="fab fa-youtube"></i>
            </div>
            <div class="yt-channel-info">
              <span class="yt-channel-name">Joint Saree</span>
              <span class="yt-channel-label">Collection</span>
            </div>
          </a>

          <a
            href="https://youtube.com/&#64;beautybloomboutique?si=KVxBSxKv4ji6J4Tf"
            target="_blank"
            rel="noopener noreferrer"
            class="yt-channel-card"
          >
            <div class="yt-icon-wrap">
              <i class="fab fa-youtube"></i>
            </div>
            <div class="yt-channel-info">
              <span class="yt-channel-name">Full Saree</span>
              <span class="yt-channel-label">Collection</span>
            </div>
          </a>

          <a
            href="https://youtube.com/&#64;onlinebazaartamil?si=JTZjyGf5R2t4QcTd"
            target="_blank"
            rel="noopener noreferrer"
            class="yt-channel-card"
          >
            <div class="yt-icon-wrap">
              <i class="fab fa-youtube"></i>
            </div>
            <div class="yt-channel-info">
              <span class="yt-channel-name">Dresses</span>
              <span class="yt-channel-label">Collection</span>
            </div>
          </a>

        </div>
      </div>

      <!-- 3. Customer Support & Policies -->
      <div class="col-12 col-sm-6 col-lg-3 text-center">
        <h5 class="footer-title josefin-sans-bold mb-3">
          Customer Support
        </h5>

        <ul class="list-unstyled footer-links mb-4">
          <li class="mb-2">
            <a routerLink="/terms-and-conditions">Terms &amp; Conditions</a>
          </li>
          <li class="mb-2">
            <a routerLink="/privacy-policy">Privacy Policy</a>
          </li>
        </ul>

        <h5 class="footer-title josefin-sans-bold mb-3">
          Order Policies
        </h5>

        <ul class="list-unstyled footer-links mb-0">
          <li class="mb-2">
            <a routerLink="/refund-policy">Refund Policy</a>
          </li>
          <li class="mb-2">
            <a routerLink="/cancellation-policy">Cancellation Policy</a>
          </li>
        </ul>
      </div>

      <!-- 4. Contact Us -->
      <div class="col-12 col-sm-6 col-lg-3">
        <h5 class="footer-title josefin-sans-bold mb-4">
          Contact Us
        </h5>

        <ul class="list-unstyled josefin-sans-regular mb-0">

          <li class="mb-3 d-flex align-items-start gap-3">
            <i class="fas fa-map-marker-alt mt-1 text-danger"></i>
            <div>
              <strong>Shree Thangam Textiles,</strong><br>
              Budget Bazaar,<br>
              Maniram Mahal, Near Cine Priya Theater Side Gate,<br>
              Kuruvikaran 2nd Street, Annanagar,<br>
              Madurai - 625020
            </div>
          </li>

          <li class="mb-3 d-flex align-items-start gap-3">
            <i class="fas fa-phone-alt mt-1 text-danger"></i>
            <a
              href="tel:+918110007090"
              class="text-dark text-decoration-none"
            >
              +91 81100 07090
            </a>
          </li>

          <li class="d-flex align-items-start gap-3">
            <i class="fas fa-envelope mt-1 text-danger"></i>
            <a
              href="mailto:support&#64;budgetbazaar.in"
              class="text-dark text-decoration-none"
            >
              support&#64;budgetbazaar.in
            </a>
          </li>

        </ul>
      </div>

    </div>
  </div>
</section>

<!-- Footer Bottom -->
<div class="footer-bottom py-3 text-center text-white">
  <div class="container-fluid px-lg-5">
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2"
    >
      <p class="mb-0 josefin-sans-regular">
        &copy; <b>{{ currentYear }}</b> All rights reserved to
        <a
          href="https://budgetbazaar.cktechsoln.in/"
          class="text-warning text-decoration-none"
        >
          Budget Bazaar
        </a>.
      </p>

      <p class="mb-0 josefin-sans-regular">
        Designed &amp; Developed by
        <a
          href="https://cktechsoln.in/"
          target="_blank"
          rel="noopener noreferrer"
          class="text-warning text-decoration-none"
        >
          CKTech Solution Pvt Ltd
        </a>.
      </p>
    </div>
  </div>
</div>

<!-- Floating WhatsApp Button -->
<a
  href="https://wa.me/message/O5FVNJ24JGCAA1"
  target="_blank"
  rel="noopener noreferrer"
  class="floating-whatsapp"
  aria-label="Chat on WhatsApp"
>
  <i class="fab fa-whatsapp"></i>
</a>

<!-- Floating Scroll to Top Button -->
<button
  type="button"
  class="floating-scroll-top"
  (click)="scrollToTop()"
  [class.show]="showScrollTop"
  aria-label="Scroll to top"
>
  <i class="fas fa-arrow-up"></i>
</button>